import { render, staticRenderFns } from "./PublicationDocumentItem.vue?vue&type=template&id=379f4376&scoped=true&lang=pug"
import script from "./PublicationDocumentItem.vue?vue&type=script&lang=js"
export * from "./PublicationDocumentItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379f4376",
  null
  
)

export default component.exports